module.exports = {
      id: "ic-200-1s-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-200-1s-index-usage",
      toString: function () {
        return this.url;
      }
    }